function getCanvas(id){
  //首页第二屏底部canvas动画
  // console.log(id);
  var e = document.getElementById(id), u = e.getContext("2d"), a = e.width = window.innerWidth,
    n = e.height = 160, s = 16, l = [], o = null;

  function r(t) {
    this.flag = t, this.a = {}, this.b = {}, "v" == t ? (this.a.y = 0, this.b.y = n, this.a.x = h(0, n), this.b.x = h(0, n)) : "h" == t && (this.a.x = 0, this.b.x = a, this.a.y = h(0, a), this.b.y = h(0, a)), this.va = h(25, 100) / 100, this.vb = h(25, 100) / 100, this.draw = function () {
      u.strokeStyle = "rgba(255,255,255,0.5)", u.beginPath(), u.moveTo(this.a.x, this.a.y), u.lineTo(this.b.x, this.b.y), u.stroke()
    }, this.update = function () {
      "v" == this.flag ? (this.a.x += this.va, this.b.x += this.vb) : "h" == t && (this.a.y += this.va, this.b.y += this.vb), this.edges()
    }, this.edges = function () {
      "v" == this.flag ? ((this.a.x < 0 || this.a.x > a) && (this.va *= -1), (this.b.x < 0 || this.b.x > a) && (this.vb *= -1)) : "h" == t && ((this.a.y < 0 || this.a.y > n) && (this.va *= -1), (this.b.y < 0 || this.b.y > n) && (this.vb *= -1))
    }
  }
  for (var t = 0; t < s; t++) {
    var i = new r(t % 2 == 0 ? "h" : "v");
    l.push(i)
  }
  function d() {
    o = window.requestAnimationFrame(d), u.clearRect(0, 0, a, n);
    for (var t = 0; t < l.length; t++) {
      (i = l[t]).draw(), i.update()
    }
    for (t = 0; t < l.length; t++) for (var i = l[t], e = t + 1; e < l.length; e++) {
      p(i, l[e])
    }
  }
  function c() {
    for (var t = l.length = 0; t < s; t++) {
      var i = new r(t % 2 == 0 ? "h" : "v");
      l.push(i)
    }
    o && (window.cancelAnimationFrame(o), o = null), a = e.width = window.innerWidth, a / 2, n = e.height = 160, n / 2, d()
  }
  function p(t, i) {
    var e, a = t.a, n = t.b, s = i.a, l = i.b, o = (l.y - s.y) * (n.x - a.x) - (l.x - s.x) * (n.y - a.y),
      r = ((l.x - s.x) * (a.y - s.y) - (l.y - s.y) * (a.x - s.x)) / o,
      d = ((n.x - a.x) * (a.y - s.y) - (n.y - a.y) * (a.x - s.x)) / o, c = a.x + r * (n.x - a.x),
      p = a.y + r * (n.y - a.y);
    0 < r && 0 < d && (e = {
      x: c,
      y: p
    }, u.beginPath(), u.arc(e.x, e.y, 2, 0, 2 * Math.PI), u.fillStyle = "rgba(255,255,255,0.5)", u.fill())
  }
  function h(t, i) {
    return 5 * ~~(Math.random() * (i - t + 1) + t)
  }
  setTimeout(function () {
    c(), addEventListener("resize", c, !1)
  }, 15)
}

function startAtonce(callback0,callback1){
  // console.log(document.cookie);
  let cookieKey = document.cookie.indexOf('SESSIONIDND=');
  if(cookieKey==-1){
    //未登录
    callback0();
  }else{
    //已登录
    callback1();
  }
}

export {getCanvas,startAtonce}



// WEBPACK FOOTER //
// ./src/api/common.js